import React from 'react';
import Header from './Header';
import Footer from './Footer';
import Seo from './Seo';
import Cursor from './ui/Cursor';
import Hero from './home/Hero';
import TrustBar from './home/TrustBar';
import Statement from './home/Statement';
import Services from './home/Services';
import HowItWorks from './home/HowItWorks';
import Gallery from './home/Gallery';
import Bakery from './home/Bakery';
import Social from './home/Social';
import LocationCta from './home/LocationCta';
import MobileCta from './home/MobileCta';

export default function Home() {
  return (
    <div className="min-h-screen bg-white overflow-x-clip">
      <Seo
        path="/"
        description="Premium pet grooming, spa and bakery in Orlando, FL. Full spa packages, cat grooming, luxurious baths and pet-safe bakery treats. Book online — (407) 868-8608."
      />
      <Cursor />
      <Header />
      <main>
        <Hero />
        <TrustBar />
        <Statement />
        <Services />
        <HowItWorks />
        <Gallery />
        <Bakery />
        <Social />
        <LocationCta />
      </main>
      <MobileCta />
      <Footer />
    </div>
  );
}
